import restCrudActions from '../../../np-crud/store/restCrudActions'
import { getAxiosInstance } from '../../../np-rest/rest';
import { snackActions } from '../../../sc-utilities/SnackBar';


// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: '/billing/delivery-note',
    pluginName: 'ADMIN',
    entityName: 'DELIVERY_NOTES',
    fetchSuccessMessage: '',
    loadSuccessMessage: '',
    createFailedUseBackendMessage: true,
    createSuccessUseBackendMessage: true
});

// Fetch DeliveryNote action creators
export const fetchDeliveryNotesInit = () => {
    return crudActions.fetchInit();
};
export const fetchDeliveryNotesStart = () => {
    return crudActions.fetchStart();
};
export const fetchDeliveryNotesSuccess = (fetchDeliveryNotesCount, listDeliveryNotesCount) => {
    return crudActions.fetchSuccess(fetchDeliveryNotesCount, listDeliveryNotesCount);
};
export const fetchDeliveryNotesFail = () => {
    return crudActions.fetchFail();
};

export const fetchDeliveryNotesCount = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchDeliveryNotesStart());
        try {
            let countRes = await rest.post("/delivery-note/count", filterData);
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    dispatch(fetchDeliveryNotesSuccess(0, []));
                }
                return countRes.data.result.data
            }
            dispatch(fetchDeliveryNotesFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch delivery notes."}`,
                options: {
                    variant: 'warning'
                }
            });
            return 0;
        } catch (error) {
            dispatch(fetchDeliveryNotesFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch delivery notes."}`,
                options: {
                    variant: 'error'
                }
            });
            return 0;
        }
    }
}
export const fetchDeliveryNotes = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchDeliveryNotesStart());
        try {
            let listRes = await rest.post("/delivery-note/list", filterData);
            if (listRes.data && listRes.data.succeeded) {
                dispatch(fetchDeliveryNotesSuccess(filterData.count, listRes.data.result.data));
                return listRes.data.result.data
            }
            dispatch(fetchDeliveryNotesFail());
            return []
        } catch (error) {
            dispatch(fetchDeliveryNotesFail());
            return []
        }
    }
}

export const loadCustomers = (id) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/customers/list', { listAll: true, ...id });
            if (res.data && res.data.succeeded) {
                const customers = [];
                for (var customer of res.data.result.data) {
                    customers.push({ value: customer.CustomerID, label: `${customer.Name}` });
                }
                return customers;
            }
            else {
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'error'
                    }
                });
                return [];

            }
        } catch (error) {
            return [];
        }
    };
}
